import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw, RouteLocationNormalized } from 'vue-router';
import { watch, type App } from 'vue';
import i18n from '@/locales';
const { t } = i18n.global;

export const routes: Array<RouteRecordRaw> = [];
interface Moudle {
  default: RouteRecordRaw
}

// 将modules下的全部路由配置文件加载到routes中
const moduleRouterList = import.meta.glob('../pages/routers/*.ts', { eager: true });
for (const path in moduleRouterList) {
  const routerInstance = (moduleRouterList[path] as Moudle).default;
  // 自动关联routers与views 下的同名文件
  routerInstance.component = () => import(`@/pages/views/${routerInstance.name as string}.vue`);
  routes.push(routerInstance);
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

router.beforeResolve(async to => {
  if (to.meta.title) {
    if (typeof to.meta.title === 'string' && (to.meta.title as string).startsWith('router.')) {
      window.document.title = t(to.meta.title as string);
    } else {
      window.document.title = to.meta.title as string;
    }
  }
});

// Watch for locale changes to update the title
 
// @ts-ignore
watch(() => i18n.global.locale.value, () => {
  const to = router.currentRoute.value;
  if (to.meta.title) {
    if (typeof to.meta.title === 'string' && (to.meta.title as string).startsWith('router.')) {
      window.document.title = t(to.meta.title as string);
    } else {
      window.document.title = to.meta.title as string;
    }
  }
});
